import { cancelAshleySpeech, speakAshley } from "../../../ashley/speech/ashleySpeech";
import { TEMPORARY_RELEASE_BRIEF_NARRATION } from "./briefNarrationScript";

let activeBriefVideo = null;

/**
 * Stops any in-progress Product Education narration playback (TTS + brief video).
 */
export function stopEducationNarration() {
  cancelAshleySpeech();

  if (!activeBriefVideo) {
    return;
  }

  try {
    activeBriefVideo.pause();
    activeBriefVideo.currentTime = 0;
  } catch (_error) {
    // Ignore teardown errors from detached media nodes.
  }

  activeBriefVideo = null;
}

/**
 * Plays muted Ashley guide video for motion and speaks the temporary brief script via TTS.
 *
 * @param {HTMLVideoElement | null | undefined} videoElement
 * @returns {Promise<boolean>} Resolves true when muted video playback starts.
 */
export function playBriefNarration(videoElement) {
  if (!videoElement) {
    return Promise.resolve(false);
  }

  stopEducationNarration();
  activeBriefVideo = videoElement;
  videoElement.currentTime = 0;
  videoElement.muted = true;

  speakAshley(TEMPORARY_RELEASE_BRIEF_NARRATION);

  return videoElement
    .play()
    .then(() => true)
    .catch(() => {
      stopEducationNarration();
      return false;
    });
}

/**
 * @param {import('../../releaseTour/briefScriptResolver').BriefScript | object} _briefScript
 * @param {{ videoElement?: HTMLVideoElement | null }} [options]
 * @returns {Promise<boolean>}
 */
export function onBriefMedia(_briefScript, { videoElement } = {}) {
  return playBriefNarration(videoElement);
}

export function speakEducationText(_text, _options = {}) {
  return Promise.resolve();
}

export function onStepMedia(_step) {
  // Tour step narration arrives in a later phase.
}
